// extracted by mini-css-extract-plugin
export default {"RemovedItemDetail":"styles_RemovedItemDetail__MKPN7","RemovedItemDetail__selected":"styles_RemovedItemDetail__selected__alcRQ"};